import { useState, useEffect } from 'react';
import './staticVideoLogo.css';

const LOGO_SRC = 'https://ranjanprabhu7.github.io/amp/deprecated/assets/Zazz_logo_128x128_White.mp4';

export default function StaticVideoLogo({ width = 20, height = 20 }) {
  const [isDarkTheme, setIsDarkTheme] = useState(() => {
    if (typeof document === 'undefined') return false;
    const el = document.querySelector('[qontento-widget]');
    return !!el?.classList?.contains('dark-theme');
  });

  useEffect(() => {
    const el = document.querySelector('[qontento-widget]');
    if (el) setIsDarkTheme(!!el.classList?.contains('dark-theme'));
  }, []);

  const filterValue = isDarkTheme ? 'invert(1)' : 'invert(5%)';

  return (
    <video
      className="vosp-logo-video"
      style={{ width: `${width}px`, height: `${height}px`, filter: filterValue }}
      src={LOGO_SRC}
      playsInline
      loop
      autoPlay
      muted
      preload="auto"
      aria-label="Zazz logo"
    />
  );
}
